// App.js
import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
// import WheelPage from "./components/WheelPage";
import WheelWrapper from "./components/WheelWrapper";
import OnlineWheelPageSZJP from "./components/OnlineWheelPageSZJP";
import UserHistoryPage from "./components/UserHistoryPage";
import OnlineInfoPage from "./components/OnlineInfoPage";
import AdminWrapper from "./components/AdminWrapper";
import LoginPage from "./components/LoginPage";
import DashbordPage from "./components/DashbordPage";
import ValidatePage from "./components/validatePage";
import AdvertisPage from "./components/advertisPage";
import Tickethistory from "./components/tickethistoryPage";
import ReportsPage from "./components/reports/ReportsPage";
// import ReportsWrapper from "./components/reports/ReportsWrapper";
import ProfiSharePage from "./components/profit-share-report/ProfitSharePage";
import BettingShop from "./components/betting-shop/BettingShop";
import UserManagement from "./components/user-management/UserManagement";
import ShiftManagement from "./components/shift-management/ShiftManagement";
import ShiftHistory from "./components/shift-history/ShiftHistory";
import ShiftReview from "./components/shift-review/ShiftReview";
import ShiftCheckout from "./components/shift-checkout/ShiftCheckout";
import axios from 'axios';
import { io } from 'socket.io-client';
import { API_URL, SOCKET_URL } from './components/environment';
import {
  ONLINE_AUTO_BET_SUBMIT_START,
  ONLINE_ROUND_SECONDS,
} from './components/onlineRouletteTiming';

import "./styles.css";
import "./components/shift-history/LoadingSpinner.css";


// =====================
// LoadingContext
// =====================
const LoadingContext = createContext();
export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};
const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading, showModal, setShowModal }}>
      {children}
    </LoadingContext.Provider>
  );
};

// =====================
// Loader component
// =====================
const Loader = () => (
  <div className="loading-spinner-one">
    <div className="spin1-border">

      <div className="spin1-number">
        <div className="spin1-number__text">
          <span className="spin1-number__text-big">LOADING...</span>
        </div>
      </div>

    </div>
  </div>
);
// =====================
// Modal component
// =====================

const ModalPopup = () => {
  const { showModal, setShowModal } = useLoading();

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={() => setShowModal(false)}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h2>New shift added for review</h2>
        {/* <p>New shift added for review</p> */}
        <div className="notif-modal-btn-wrap">
          <button onClick={() => setShowModal(false)}>Close</button>
        </div>
      </div>
    </div>
  );
};
// =====================
// RouteChangeLoader (2s delay)
// =====================
const ONLINE_GAME_ROUTES = ['/onlineroulette', '/userhistory', '/paytable', '/rules'];
// Switch to the wheel when automatic bet submission starts, five seconds later than before.
const ONLINE_SPIN_REDIRECT_START = ONLINE_AUTO_BET_SUBMIT_START;
const ONLINE_FORCE_WHEEL_VIEW_EVENT = 'onlineRoulette:forceWheelView';
const ONLINE_FORCE_WHEEL_VIEW_KEY = 'sun_online_roulette_force_wheel_view';

const getOnlineLaunchQueryString = (search = '') => {
  const params = new URLSearchParams(search);
  const launchToken = params.get('launchToken') || params.get('launch_token') || params.get('token') || '';

  return launchToken ? `?launchToken=${encodeURIComponent(launchToken)}` : '';
};

const isOnlineSpinRedirectWindow = (timer) => {
  const timerSeconds = Number(timer);

  return Number.isFinite(timerSeconds) &&
    timerSeconds >= ONLINE_SPIN_REDIRECT_START &&
    timerSeconds < ONLINE_ROUND_SECONDS;
};

const RouteChangeLoader = () => {
  const location = useLocation();
  const { setIsLoading } = useLoading();

  useEffect(() => {
    if (ONLINE_GAME_ROUTES.includes(location.pathname)) {
      setIsLoading(false);
      return undefined;
    }

    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, [location.pathname, setIsLoading]);

  return null;
};

const OnlineSpinRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const latestLocationRef = useRef(location);

  useEffect(() => {
    latestLocationRef.current = location;
  }, [location]);

  useEffect(() => {
    if (!ONLINE_GAME_ROUTES.includes(location.pathname)) {
      return undefined;
    }

    let hasRedirectedForCurrentSpin = false;
    const socket = io(SOCKET_URL, { autoConnect: false });

    const forceWheelView = () => {
      try {
        window.sessionStorage.setItem(ONLINE_FORCE_WHEEL_VIEW_KEY, String(Date.now()));
      } catch (error) {
        // Ignore storage availability issues; the live event still collapses the wheel page.
      }

      window.dispatchEvent(new Event(ONLINE_FORCE_WHEEL_VIEW_EVENT));
    };

    const redirectToWheel = () => {
      const latestLocation = latestLocationRef.current;

      if (!ONLINE_GAME_ROUTES.includes(latestLocation.pathname)) {
        return;
      }

      forceWheelView();

      if (latestLocation.pathname !== '/onlineroulette') {
        navigate(`/onlineroulette${getOnlineLaunchQueryString(latestLocation.search)}`, { replace: true });
      }
    };

    socket.on('connect', () => {
      socket.emit('authentication', { username: 'sadmin', password: 'Admin776!' });
    });

    socket.on('authentication_response', () => {
      socket.emit('join_room', { room: 'wheel' });
      socket.emit('join_room', { room: 'customer' });
    });

    socket.on('timer', (data) => {
      const isSpinWindow = isOnlineSpinRedirectWindow(data?.timer);

      if (isSpinWindow && !hasRedirectedForCurrentSpin) {
        hasRedirectedForCurrentSpin = true;
        redirectToWheel();
      } else if (!isSpinWindow) {
        hasRedirectedForCurrentSpin = false;
      }
    });

    socket.open();

    return () => {
      socket.close();
    };
  }, [location.pathname, navigate]);

  return null;
};

// =====================
// PrivateRoute
// =====================
const PrivateRoute = ({ element }) => {
  const { user } = useAuth();
  return user ? element : <Navigate to="/login" replace />;
};

// =====================
// Main App Component
// =====================
function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <Router>
          <AppContent />
        </Router>
      </LoadingProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const { isLoading, setShowModal } = useLoading();

  useEffect(() => {
    // run this for auditor and cashier roles
    const poller = setInterval(async () => {
      // check current user and current role in local storage
      const role = localStorage.getItem("sun_userRole");
      const isAuditor = role === 'AUDITOR';
      const userId = localStorage.getItem("sun_userId") || '';
      if (isAuditor && userId) {
        try {
          const response = await axios.post(API_URL + "/check-auditor-notif", {
            agentId: userId,
          });
          if (response.data && response.data.hasNotification === "yes") {
            setShowModal(true);
          } else {
            setShowModal(false);
          }
        } catch (err) {
          console.error("API poll failed:", err);
        }
      }

      // track betting shop online
      // condition for betting shop
      const isCashier = role === 'CASHIER';
      if (isCashier && userId) {
        // update online status for betting shop by id, get from local storage
        const storedShopId = localStorage.getItem('sun_bettingShopId') || '';
        try {
          await axios.put(API_URL + "/betshlastactivity", {
            bettingShopId: storedShopId,
          });

        } catch (err) {
          console.error("Lastatcivity API call failed:", err);
        }
      }

      // last activity for all users
      if (userId) {
        try {
          await axios.put(API_URL + "/userlastactivity", {
            agentId: userId,
          });
        } catch (err) {
          console.error("Lastatcivity API call failed:", err);
        }
      }

    }, 15000);
  
    return () => clearInterval(poller);
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <ModalPopup /> {/* Global Modal */}
      <RouteChangeLoader />
      <OnlineSpinRedirect />
      <Routes>
          <Route path="/" element={<WheelWrapper />} />
          <Route path="/onlineroulette" element={<OnlineWheelPageSZJP />} />
          <Route path="/userhistory" element={<UserHistoryPage />} />
          <Route path="/paytable" element={<OnlineInfoPage title="Pay Table" />} />
          <Route path="/rules" element={<OnlineInfoPage title="Rules" />} />
          <Route path="/login" element={<LoginPage />} />

          {/* <Route path="/dashboard" element={<DashbordPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/validate" element={<ValidatePage />} />
          <Route path="/advertis" element={<AdvertisPage />} />
          <Route path="/tickethistory" element={<Tickethistory />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/betting-shop" element={<BettingShop />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/shift-management" element={<ShiftManagement />} /> */}
          {/* ✅ Protected Routes */}
          <Route path="/dashboard" element={<PrivateRoute element={<DashbordPage />} />} />
          <Route path="/admin" element={<PrivateRoute element={<AdminWrapper />} />} />
          <Route path="/validate" element={<PrivateRoute element={<ValidatePage />} />} />
          <Route path="/advertis" element={<PrivateRoute element={<AdvertisPage />} />} />
          <Route path="/tickethistory" element={<PrivateRoute element={<Tickethistory />} />} />
          <Route path="/reports" element={<PrivateRoute element={<ReportsPage />} />} />
          <Route path="/profitshare-report" element={<PrivateRoute element={<ProfiSharePage />} />} />
          <Route path="/betting-shop" element={<PrivateRoute element={<BettingShop />} />} />
          <Route path="/user-management" element={<PrivateRoute element={<UserManagement />} />} />
          <Route path="/shift-management" element={<PrivateRoute element={<ShiftManagement />} />} />
          <Route path="/shift-history" element={<PrivateRoute element={<ShiftHistory />} />} />
          <Route path="/shift-review" element={<PrivateRoute element={<ShiftReview />} />} />
          <Route path="/shift-checkout/:shiftId?" element={<PrivateRoute element={<ShiftCheckout />} />} />


          

          {/* <Route path="/wheel" element={<WheelTest />} /> */}
      </Routes>
    </>
  );
}

export default App;
